import { getDefaultAttributes, trackEvent } from 'core-lib/utils/events';

export enum TestDriveEvents {
  PageLoaded = 'page loaded',
  BookTestDriveClicked = 'book_test_drive_clicked',
  LeadSubmitted = 'lead_submitted',
  FilterSelected = 'filter_selected',
  SeeAllClicked = 'see_all_clicked',
  SearchClicked = 'search_clicked',
  SearchSubmitted = 'search_submitted',
  MyBookingsClicked = 'my_bookings_clicked',
  ExploreNowClicked = 'explore_now_clicked',
  CancelBookingClicked = 'cancel_booking_clicked',
  ViewCarDetailsClicked = 'view_car_details_clicked',
  ModelUnselected = 'model_unselected',
  ModelSelected = 'model_selected',
  CarsCompared = 'cars_compared',
  ReviewsViewed = 'reviews_viewed',
  KnowHowClicked = 'know_how_clicked',
  TestDriveTaken = 'test_drive_taken',
  BillUploaded = 'bill_uploaded',
  BookingShared = 'booking_shared',
  FeedbackSubmitted = 'feedback_submitted',
  MultipleTestDriveViewed = 'multiple_test_drive_viewed',
  MyBookingViewed = 'my_booking_viewed',
  BannerClicked = 'banner_clicked',
  ViewSpecsClicked = 'View specs clicked',
  CardClicked = 'card_clicked',
  DraftClicked = 'draft_clicked',
  ButtonClicked = 'button_clicked',
  carSwiped = 'car_swiped',
  carVoted = 'car_voted',
  reviewClicked = 'review_clicked',
  DirectoryBannerClicked = 'directory_banner_clicked',
  PermissionGranted = 'permission_granted',
  ViewContactsClicked = 'view_contacts_clicked',
  NullContactsFetched = 'null_contacts_fetched',
  ViewDetailsClicked = 'view_details_clicked',
  CtaClicked = 'cta_clicked',
  PopupViewed = 'popup_viewed',
}

export enum PageNames {
  LandingPage = 'Landing',
  Search = 'Search',
  MyBookings = 'My Bookings',
  Leads = 'Vehicle details',
  ConfirmationPage = 'Booking confirmation',
  Listing = 'Listings',
  Finder = 'Finder',
  MultipleTestDrives = 'Multiple test drives ',
  CarFinderQuiz = 'Car finder quiz',
  CarReview = 'Car review',
  CarFinder = 'Car finder',
  TelephoneDirectory = 'Telephone directory',
  Reviews = 'Reviews',
  Contacts = 'Contacts',
  NewCarHome = 'new_car_home',
}

export enum Attributes {
  ModelId = 'model',
  OptionSelected = 'option_selected',
  Category = 'category',
  SubCategory = 'subcategory',
  PageName = 'page_name',
  Section = 'section',
  CtaName = 'cta_name',
  Leads = 'leads'
}

export const trackTestDriveEvents = (eventName, attributes) => {
  trackEvent({
    name: eventName,
    defaultAttr: getDefaultAttributes(),
    attributes: {
      [Attributes.Category]: 'Services',
      [Attributes.SubCategory]: 'Test Drive',
      ...attributes,
    },
  });
};
